module.exports = __webpack_public_path__ + "img/overtime_icon.a755b671.svg";